import React from "react";
import {  Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  EmptyListPage,
  TableHeader,
} from "../../../components/commons";
import { ALLOCATION_HEADER } from "../../../constant/invoiceListConst";
import AllocationBody from "./AllocationBody";
import "./allocation.scss";
import { NoFile } from "../../../assets/images";
import { GetAllocationPayloadType } from "../../../commonTypes/invoiceGenerationTypes";

type AppProps = {
  isOpen: boolean;
  toggleAllocationModal: () => void;
  allAllocatedPaymentRowsData: any;
  allocatedAmount: number;
  remainingAmount: number;
  currencySign: string | undefined;
  handleChangeAmount: (data: number, id: number) => void;
  handleSaveAllocatedAmount: () => void;
  allocationSingleRowData:GetAllocationPayloadType;
  toggleWithOutSavingData:()=>void;
  handleCancel:()=>void;
};

const AllocationModal = ({
  isOpen,
  toggleAllocationModal,
  allAllocatedPaymentRowsData,
  allocatedAmount,
  remainingAmount,
  handleChangeAmount,
  handleSaveAllocatedAmount,
  currencySign,
  allocationSingleRowData,
  toggleWithOutSavingData,
  handleCancel
}: AppProps) => {

  const handleHeader = () => {
    return (
      <tr>
        <th
          style={{ backgroundColor: "#e8ecf0",border:"1px solid #e8ecf0",color:"#464f60" }}
          colSpan={allocatedAmount < 0 ? 2 : 3}
        >
          {"AMOUNT TO BE ALLOCATED"}
        </th>
        <th
          style={{ backgroundColor: "#e8ecf0",border:"1px solid #e8ecf0"}}
          colSpan={allocatedAmount < 0 ? 2 : 1}
        >
          <div
            className={`box_with_shadow ${
              allocatedAmount > 0
                ? "allocated-green"
                : allocatedAmount < 0
                ? "allocated-error"
                : "allocated-zero"
            }`}
          >
            {allocatedAmount >= 0 && (
              <span className="mr-1">{currencySign}</span>
            )}
            <span>
              {allocatedAmount < 0
                ? "You don't have sufficient amount to allocate"
                : allocatedAmount ? (+allocatedAmount)?.toFixed(2) : 0}
            </span>
          </div>
        </th>
        <th style={{ backgroundColor: "#e8ecf0",border:"1px solid #e8ecf0" }}>
          <span className="mr-1">{currencySign}</span>
          <span>{remainingAmount ? +remainingAmount?.toFixed(2) : 0}</span>
        </th>
      </tr>
    );
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggleAllocationModal}
        backdrop="static"
        size="lg"
      >
        <ModalHeader toggle={()=>{
          toggleAllocationModal();
          handleCancel();
        }}>
        {!!allocationSingleRowData?.othersPaymentId && allAllocatedPaymentRowsData[ allocationSingleRowData?.othersPaymentId]?.length  ? "Allocate your available balance" : ""}
        </ModalHeader>
        <ModalBody style={{ width: "100%" }}>
          <div className="allocation">
            {!!allocationSingleRowData?.othersPaymentId && allAllocatedPaymentRowsData[allocationSingleRowData?.othersPaymentId]?.length ? (
              <table className="table">
                <thead className="sticky-table-header thead-light">
                  {handleHeader()}
                  <TableHeader tableHeader={ALLOCATION_HEADER} />
                </thead>
                <tbody>
                  <AllocationBody
                    currencySign={currencySign}
                    tableHeader={ALLOCATION_HEADER}
                    paymentPendingList={allAllocatedPaymentRowsData[allocationSingleRowData?.othersPaymentId]}
                    handleChangeAmount={handleChangeAmount}
                  />
                </tbody>
              </table>
            ) : (
              <EmptyListPage
                title="No Invoice Found ! "
                image={NoFile}
                imageWidth="30%"
                showLinkButton={false}
                showAddButton={false}
              />
            )}
          </div>
        </ModalBody>

        <ModalFooter>
          <button
            className="mr-2 btn btn-outline"
            onClick={()=>{
              toggleAllocationModal()
              toggleWithOutSavingData()            
            }}
          >
          {allocationSingleRowData?.othersPaymentId && allAllocatedPaymentRowsData[allocationSingleRowData?.othersPaymentId]?.length ?  "Exit Without Saving" : "Exit"}
          </button>
         {allocationSingleRowData?.othersPaymentId && allAllocatedPaymentRowsData[allocationSingleRowData?.othersPaymentId]?.length ?  <button
            className="btn btn-primary"
            disabled={allocatedAmount < 0}
            onClick={handleSaveAllocatedAmount}
          >
            Save
          </button> :null}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AllocationModal;
